import $cookies from "js-cookie";

export default {
    checkLogin(){
        let cookie_arr = $cookies.get("my")
        cookie_arr = (cookie_arr || "").split("|")
        let uid = cookie_arr[0]
        if(uid) {
            return true
        }
        return false
    },
    validPhone(phone){
        if (!/^1[3456789]\d{9}$/.test(phone)){
            return false
        }
        return true
    },
}




// WEBPACK FOOTER //
// ./src/plugins/checkLogin.js